import { motion } from "framer-motion";
import ReelPlayer from "@/components/ReelPlayer";

const EASE = [0.16, 1, 0.3, 1];

export default function Film() {
  return (
    <section id="film" data-testid="film-section" className="px-6 pb-28 pt-4 md:px-10 md:pb-36">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 1, ease: EASE }}
        className="mx-auto max-w-7xl"
      >
        <ReelPlayer
          videoUrl="https://player.vimeo.com/video/1219830757"
          poster="/assets/film-poster.jpg"
          testIdPrefix="film"
        />
      </motion.div>
    </section>
  );
}
